module.exports = __webpack_public_path__ + "img/carrusel_2.749231ad.jpg";